// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   LIMIT REACHED MODAL
   Dashboard modal system alignment
   ============================================ */

.limit-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.82);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
}

.limit-modal-content {
  width: min(100%, 480px);
  max-height: min(88vh, 760px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0) 24%),
    #0d1117;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow:
    0 24px 80px rgba(0, 0, 0, 0.55),
    0 0 0 1px rgba(255, 255, 255, 0.04) inset;
  animation: modalSlideIn 0.2s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.limit-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0));
}

.limit-modal-header h2 {
  color: #fff;
  font-family: var(--font-primary, system-ui, -apple-system, sans-serif);
  font-size: 1.05rem;
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.01em;
}

.limit-modal-close {
  width: 32px;
  height: 32px;
  padding: 0;
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.18);
  border-radius: 8px;
  color: #f87171;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.limit-modal-close:hover {
  color: #fff;
  background: rgba(239, 68, 68, 0.14);
  border-color: rgba(239, 68, 68, 0.3);
}

.limit-modal-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 24px 22px;
}

.limit-modal-body::-webkit-scrollbar {
  width: 6px;
}

.limit-modal-body::-webkit-scrollbar-track {
  background: transparent;
}

.limit-modal-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.14);
  border-radius: 999px;
}

.limit-modal-body::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.22);
}

.limit-message {
  color: #d1d5db;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 20px;
}

.limit-usage-display {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
  padding: 16px;
  background: rgba(239, 68, 68, 0.08);
  border-radius: 10px;
  border: 1px solid rgba(239, 68, 68, 0.18);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.limit-usage-current {
  font-size: 2rem;
  font-weight: 700;
  color: #ef4444;
  font-family: var(--font-primary, system-ui, -apple-system, sans-serif);
}

.limit-usage-separator {
  font-size: 1.5rem;
  color: rgba(255, 255, 255, 0.3);
}

.limit-usage-limit {
  font-size: 2rem;
  font-weight: 700;
  color: #9ca3af;
  font-family: var(--font-primary, system-ui, -apple-system, sans-serif);
}

.limit-benefits {
  margin-top: 20px;
}

.limit-benefits h3 {
  color: #f3f4f6;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 12px;
  font-family: var(--font-primary, system-ui, -apple-system, sans-serif);
}

.limit-benefits ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.limit-benefits li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: #d1d5db;
  font-size: 0.88rem;
  line-height: 1.5;
}

.check-icon {
  color: #f87171;
  flex-shrink: 0;
  margin-top: 2px;
}

.limit-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.025), rgba(255, 255, 255, 0));
}

.limit-modal-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 0.88rem;
  font-weight: 600;
  font-family: var(--font-primary, system-ui, -apple-system, sans-serif);
  cursor: pointer;
  transition: all 0.15s ease;
  border: 1px solid transparent;
}

.limit-modal-btn-secondary {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.12);
  color: #d1d5db;
}

.limit-modal-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.18);
  color: #fff;
}

.limit-modal-btn-primary {
  background: #ef4444;
  color: #fff;
  box-shadow: 0 6px 24px rgba(239, 68, 68, 0.22);
}

.limit-modal-btn-primary:hover {
  background: #dc2626;
  box-shadow: 0 10px 28px rgba(239, 68, 68, 0.32);
}

@media (max-width: 1800px) {
  .limit-modal-overlay {
    padding: 16px;
  }

  .limit-modal-content {
    width: min(100%, 440px);
    max-height: min(86vh, 720px);
    border-radius: 14px;
  }

  .limit-modal-header {
    gap: 14px;
    padding: 18px 20px 14px;
  }

  .limit-modal-header h2 {
    font-size: 1rem;
  }

  .limit-modal-body {
    padding: 18px 20px 20px;
  }

  .limit-message {
    font-size: 0.86rem;
    margin-bottom: 18px;
  }

  .limit-usage-display {
    gap: 7px;
    margin-bottom: 20px;
    padding: 14px;
    border-radius: 9px;
  }

  .limit-usage-current,
  .limit-usage-limit {
    font-size: 1.75rem;
  }

  .limit-usage-separator {
    font-size: 1.3rem;
  }

  .limit-benefits {
    margin-top: 18px;
  }

  .limit-benefits h3 {
    margin-bottom: 10px;
  }

  .limit-benefits ul {
    gap: 8px;
  }

  .limit-benefits li {
    gap: 9px;
    font-size: 0.84rem;
  }

  .limit-modal-footer {
    gap: 10px;
    padding: 14px 20px;
  }

  .limit-modal-btn {
    padding: 9px 18px;
    font-size: 0.84rem;
  }
}

@media (max-width: 768px) {
  .limit-modal-overlay {
    padding: 12px;
    align-items: flex-end;
  }

  .limit-modal-content {
    width: 100%;
    max-height: min(92vh, 840px);
    border-radius: 18px;
  }
}

@media (max-width: 480px) {
  .limit-modal-header,
  .limit-modal-body,
  .limit-modal-footer {
    padding-left: 18px;
    padding-right: 18px;
  }

  .limit-modal-footer {
    flex-direction: column-reverse;
  }

  .limit-modal-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LimitReachedModal.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB;;WAES;EACT,mBAAmB;EACnB,0CAA0C;EAC1C;;6CAE2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,kDAAkD;EAClD,sFAAsF;AACxF;;AAEA;EACE,WAAW;EACX,sEAAsE;EACtE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4EAA4E;AAC9E;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,yCAAyC;EACzC,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sEAAsE;AACxE;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sEAAsE;AACxE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sEAAsE;AACxE;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,qFAAqF;AACvF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sEAAsE;EACtE,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,mBAAmB;IACnB,aAAa;IACb,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;EACrB;AACF;;AAEA;EACE;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* ============================================\n   LIMIT REACHED MODAL\n   Dashboard modal system alignment\n   ============================================ */\n\n.limit-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.82);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.limit-modal-content {\n  width: min(100%, 480px);\n  max-height: min(88vh, 760px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0) 24%),\n    #0d1117;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow:\n    0 24px 80px rgba(0, 0, 0, 0.55),\n    0 0 0 1px rgba(255, 255, 255, 0.04) inset;\n  animation: modalSlideIn 0.2s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.limit-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0));\n}\n\n.limit-modal-header h2 {\n  color: #fff;\n  font-family: var(--font-primary, system-ui, -apple-system, sans-serif);\n  font-size: 1.05rem;\n  font-weight: 600;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.limit-modal-close {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: rgba(239, 68, 68, 0.08);\n  border: 1px solid rgba(239, 68, 68, 0.18);\n  border-radius: 8px;\n  color: #f87171;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;\n}\n\n.limit-modal-close:hover {\n  color: #fff;\n  background: rgba(239, 68, 68, 0.14);\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n.limit-modal-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px 24px 22px;\n}\n\n.limit-modal-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.limit-modal-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.limit-modal-body::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.14);\n  border-radius: 999px;\n}\n\n.limit-modal-body::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.22);\n}\n\n.limit-message {\n  color: #d1d5db;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n.limit-usage-display {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 24px;\n  padding: 16px;\n  background: rgba(239, 68, 68, 0.08);\n  border-radius: 10px;\n  border: 1px solid rgba(239, 68, 68, 0.18);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);\n}\n\n.limit-usage-current {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #ef4444;\n  font-family: var(--font-primary, system-ui, -apple-system, sans-serif);\n}\n\n.limit-usage-separator {\n  font-size: 1.5rem;\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.limit-usage-limit {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #9ca3af;\n  font-family: var(--font-primary, system-ui, -apple-system, sans-serif);\n}\n\n.limit-benefits {\n  margin-top: 20px;\n}\n\n.limit-benefits h3 {\n  color: #f3f4f6;\n  font-size: 0.85rem;\n  font-weight: 600;\n  margin-bottom: 12px;\n  font-family: var(--font-primary, system-ui, -apple-system, sans-serif);\n}\n\n.limit-benefits ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.limit-benefits li {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  color: #d1d5db;\n  font-size: 0.88rem;\n  line-height: 1.5;\n}\n\n.check-icon {\n  color: #f87171;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.limit-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  background: linear-gradient(0deg, rgba(255, 255, 255, 0.025), rgba(255, 255, 255, 0));\n}\n\n.limit-modal-btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 0.88rem;\n  font-weight: 600;\n  font-family: var(--font-primary, system-ui, -apple-system, sans-serif);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  border: 1px solid transparent;\n}\n\n.limit-modal-btn-secondary {\n  background: transparent;\n  border-color: rgba(255, 255, 255, 0.12);\n  color: #d1d5db;\n}\n\n.limit-modal-btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(255, 255, 255, 0.18);\n  color: #fff;\n}\n\n.limit-modal-btn-primary {\n  background: #ef4444;\n  color: #fff;\n  box-shadow: 0 6px 24px rgba(239, 68, 68, 0.22);\n}\n\n.limit-modal-btn-primary:hover {\n  background: #dc2626;\n  box-shadow: 0 10px 28px rgba(239, 68, 68, 0.32);\n}\n\n@media (max-width: 1800px) {\n  .limit-modal-overlay {\n    padding: 16px;\n  }\n\n  .limit-modal-content {\n    width: min(100%, 440px);\n    max-height: min(86vh, 720px);\n    border-radius: 14px;\n  }\n\n  .limit-modal-header {\n    gap: 14px;\n    padding: 18px 20px 14px;\n  }\n\n  .limit-modal-header h2 {\n    font-size: 1rem;\n  }\n\n  .limit-modal-body {\n    padding: 18px 20px 20px;\n  }\n\n  .limit-message {\n    font-size: 0.86rem;\n    margin-bottom: 18px;\n  }\n\n  .limit-usage-display {\n    gap: 7px;\n    margin-bottom: 20px;\n    padding: 14px;\n    border-radius: 9px;\n  }\n\n  .limit-usage-current,\n  .limit-usage-limit {\n    font-size: 1.75rem;\n  }\n\n  .limit-usage-separator {\n    font-size: 1.3rem;\n  }\n\n  .limit-benefits {\n    margin-top: 18px;\n  }\n\n  .limit-benefits h3 {\n    margin-bottom: 10px;\n  }\n\n  .limit-benefits ul {\n    gap: 8px;\n  }\n\n  .limit-benefits li {\n    gap: 9px;\n    font-size: 0.84rem;\n  }\n\n  .limit-modal-footer {\n    gap: 10px;\n    padding: 14px 20px;\n  }\n\n  .limit-modal-btn {\n    padding: 9px 18px;\n    font-size: 0.84rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .limit-modal-overlay {\n    padding: 12px;\n    align-items: flex-end;\n  }\n\n  .limit-modal-content {\n    width: 100%;\n    max-height: min(92vh, 840px);\n    border-radius: 18px;\n  }\n}\n\n@media (max-width: 480px) {\n  .limit-modal-header,\n  .limit-modal-body,\n  .limit-modal-footer {\n    padding-left: 18px;\n    padding-right: 18px;\n  }\n\n  .limit-modal-footer {\n    flex-direction: column-reverse;\n  }\n\n  .limit-modal-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
